import { Field, useField, useForm } from 'react-final-form';
import styles from './ProductItem.module.scss';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { RiDeleteBin6Line as RemoveIcon } from 'react-icons/ri';
import { getIn } from 'final-form';
import OutlinedFormInput from '../../Finance/components/OutlinedFormInput/OutlinedFormInput';
import { onBlurFormatNumber, parseNumberForDB } from '../../../components/functions/utilities';

type Props = {
    fieldIndex: number,
    fieldName: string,
    ipConfigs: any,
}

const ProductItem = ({ fieldIndex, fieldName, ipConfigs }: Props) => {
    const { mutators, getState } = useForm();
    // const { input: productItemValue } = useField(`${fieldName}`, { value: true })
    // console.log('productItemValue', productItemValue)
    const productItemValue = getIn(getState().values, fieldName);
    return (
        <div className={styles.itemRootContainer}>
            <div className={styles.topRowContainer}>
                <div className={styles.ipLogoContainer}>
                    <img src={ipConfigs[productItemValue?.integrationPartner]?.logo} alt="" />
                </div>
                <div className={styles.actionBtnContainer}>
                    <MeritoButton onClick={() => {
                        // console.log('remove image');
                        mutators.remove(`verifiedProducts`, fieldIndex)
                    }} type='destructive-ghost' icon={<RemoveIcon />} onlyIcon={true} />
                </div>
            </div>
            <div className={styles.productDetailsRow}>
                <div className={styles.productTitle}>
                    {productItemValue?.productName}
                </div>
                <div className={styles.productDetails}>
                    {productItemValue?.sku ? <div className={styles.productDetailsText}>
                        {productItemValue?.sku}
                    </div> : null}
                    {productItemValue?.sku && productItemValue?.variant ? <div className={styles.productDetailsSeparator}></div> : null}
                    <div className={styles.productDetailsText}>
                        {productItemValue?.variant}
                    </div>
                </div>
            </div>

            <Field validate={(value) => {
                if (!value) {
                    return `Enter no. of orders`
                }
            }} name={`${fieldName}.purchaseOrders`}>
                {(props) => {
                    return <OutlinedFormInput
                        {...props.input}
                        label={'Orders to Supplier in Last 12 Months'}
                        fieldType='lg'
                        placeholder={'Enter orders'}
                        showPlaceholder={false}
                        inpuType='number'

                        name={props.input.name}
                        value={props.input.value}
                        onChange={(e) => {
                            // console.log('value', e.target.value)
                            const numericValue = parseNumberForDB(e.target.value, false);
                            // console.log('numeric value', numericValue)
                            props.input.onChange(numericValue);
                        }}
                        onBlur={(e) => {

                            // console.log('onBlur triggering')
                            // if (currentMonthValue?.inEffectValue == MetricValueType.updatedCost && currentMonthValue?.updatedCost && currentMonthValue?.apiCost) {
                            const value = props.input.value;
                            // console.log('value', value);
                            // console.log('value', value);
                            const formattedValue = onBlurFormatNumber(value, 0);
                            // console.log('formattedValue', formattedValue);
                            props.input.onChange(formattedValue);
                            console.log('inputValue', value)
                            props.input.onBlur(e);
                        }}
                        error={props.meta.error}
                        touched={props.meta.touched}
                        isCurrency={true}
                        maxLength={21}
                    />
                }}
            </Field>
        </div>
    )
}

export default ProductItem;